import { z } from 'zod';
import { ErrorResponseSchema, SuccessMessageSchema } from '@/schemas/common/base';

/**
 * POST /api/addresses/[id]/deactivate response schema
 * Deactivates an address (soft delete)
 */
export const DeactivateAddressResponseSchema = z.discriminatedUnion('success', [
  SuccessMessageSchema,
  ErrorResponseSchema,
]);

export type DeactivateAddressResponse = z.infer<typeof DeactivateAddressResponseSchema>;
